import utils from "../utils";

function init() {

	subMenuVisibility();
	manuVisibility();

	var mainNav = document.getElementById("main-nav"),
		mainHeader = document.getElementById("main-header"),
		mainMenuToggler = document.getElementById("main-nav-toggler"),
		htmlTag = document.getElementsByTagName("html")[0];

	if(mainMenuToggler){
		mainMenuToggler.addEventListener("click", () => {

			let isOpen = mainNav.classList.contains("open");
			if (isOpen) {
				mainMenuToggler.setAttribute("aria-expanded", "false");
				mainNav.classList.remove("open");
				mainHeader.classList.remove("open");
				htmlTag.classList.remove("no-scroll");
			} else {
				mainMenuToggler.setAttribute("aria-expanded", "true");
				mainHeader.classList.add("open");
				mainNav.classList.add("open");
				htmlTag.classList.add("no-scroll");
			}
		});
	}
	
}

function manuVisibility(){

	var mainHeader = document.getElementById("main-header"),
		home = document.querySelector(".page.home");

	if(home){
		window.addEventListener(
			"scroll",
			function () {
				var scrollTop = document.documentElement.scrollTop,
					windowH = window.innerHeight;
	
				if (scrollTop >= windowH) {
					mainHeader.classList.add("scrolled");
				} else {
					mainHeader.classList.remove("scrolled");
				}
			},
			false
		);
	}
}

function subMenuVisibility(){
	var hasChildrenItems = document.querySelectorAll('#main-menu .menu-item-has-children > a'),
		hasChildrens = document.querySelectorAll('#main-menu .menu-item-has-children');

	if(hasChildrenItems.length > 0){
		utils.forEach(hasChildrenItems, function (index, hasChildrenItem) {
			hasChildrenItem.addEventListener("click", function (e) {
				e.preventDefault();

				utils.forEach(hasChildrens, function (index, hasChildren) {

					if(hasChildrenItem.parentElement != hasChildren){
						hasChildren.classList.remove('active');
					}

				});

				hasChildrenItem.parentElement.classList.toggle('active');
			})
		});
	}

}

export default { init };
